<template>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-4 p-0">
      <div class="card text-center p-0">
        <div class="card-header text-light bd-navbar d-flex justify-content-center p-2">
          <h5>
            <a class="text-light">Hallo!</a>
          </h5>
        </div>

        <div class="card-body i42FullLine text-body">
          <p class="card-text text-dark i42FullLine">
            Hier kannst Du Deine interessanten Inhalte hinzufügen und lesen.
          </p>
          <router-link to="/provider/add" class="btn btn-outline-info btn-block">
                <b>Inhalt hinzufügen  <span class="fas fa-plus-circle"></span></b>
              </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "User.Menu.InfoNoFeeds",
  data: function() {
    return {
      newFeed: {
        url: "",
        name: "",
        category: ""
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-navbar {
  background-color: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
</style>
